import axiosClient from "@/lib/auth";
import { CurrentShiftFetchedV2, EndShiftV2, GetCurrentShiftAlertMonitoringData, PatchEndShiftV2AlertMonitoringData, PatchEndShiftV2AlertMonitoringResponses, PutAckShiftAlertMonitoringData } from "../types.gen"
import { UseMutationOptions, UseQueryOptions } from "@tanstack/react-query";

export const fetchCurrentShift = async () => {
  const path: GetCurrentShiftAlertMonitoringData["url"] = "/AlertMonitoring/shift-v2"
  const response = await axiosClient.get<CurrentShiftFetchedV2>(path);

  return response.data
}

export const FetchCurrentShiftQuery = () => {
  return {
    queryKey: ["shift.get"],
    queryFn: () => fetchCurrentShift(),
  } satisfies UseQueryOptions
}

export const ackShift = async () => {
  const path: PutAckShiftAlertMonitoringData["url"] = "/AlertMonitoring/shift"
  const response = await axiosClient.put<CurrentShiftFetchedV2>(path)

  return response.data
}

export const AckShiftMut = () => {
  return {
    mutationKey: ["shift.ack"],
    mutationFn: () => ackShift()
  } satisfies UseMutationOptions
}

export const endShift = async () => {
  const path: PatchEndShiftV2AlertMonitoringData["url"] = "/AlertMonitoring/shift/end"
  const response = await axiosClient.patch<EndShiftV2>(path)

  return response.data
}


export const EndShiftMut = () => {
  return {
    mutationKey: ["shift.end"],
    mutationFn: () => endShift()
  } satisfies UseMutationOptions
}